// extracted by mini-css-extract-plugin
export default {"voteBar":"VoteBar_voteBar__6SB2T","votes":"VoteBar_votes__MVKaW","vetoes":"VoteBar_vetoes__MW2-j"};